import Vue from 'vue';

const success = (response, context, isFromPayments) => {
  context.error = null;
  context.success = false;
  if (isFromPayments) {
    context.openModal("#payment-modal");
    context.payment = {
      amount: null,
      type: "other",
      booking_id: null,
      customer_email: null,
      description: null
    }
    if (context.stripe_accounts && context.stripe_accounts[0] && context.stripe_accounts[0].id) {
      context.payment.stripe_account_id = context.stripe_accounts[0].id;
    }
  } else {
    context.smallLoading = true;
    context.showStripeAccount();
  }
};

const failed = (error, context) => {
  if(error.response.data.msg == 'stripe account not found'){
    swal({
        title: context.$t("modal.are_you_sure"),
        text: context.$t("modal.please_configure_account"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: context.$t("modal.go_to_account_settings"),
        closeOnConfirm: true,
        html: true
      },
      function() {
        Vue.router.push({
          name: 'account.settings',
        });
    });
  }
};

export default (context, isFromPayments = true) => {
  return Vue.$http.get('/check-users-payments-access')
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context, isFromPayments);
      }
    }).catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/payment/checkUsersPaymentAccess.js